import React from 'react';
import * as Moment from 'moment';
import { withStyles } from '@material-ui/core/styles';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import isEqual from 'lodash/isEqual';
import { isEmpty } from 'lodash';
import { FormSection, SubmissionError } from 'redux-form';
import { secondsToDays, normalizeString } from '../../../utils/misc';
import PitchPreview from './PitchPreview';
import Button from '../../buttons/Button';
import { StepsFormRedux } from './StepsForm';

const styles = () => ({
  previewStepsContainer: {
    maxHeight: '40rem',
    overflow: 'auto',
    position: 'relative',
  },
  stepsSection: {
    marginTop: '0.625rem',
  },
  stepSection: {
    marginBottom: '2rem',
  },
  stepsTitle: {},
  saveButton: {
    position: 'absolute',
    right: 0,
    top: 0,
  },
});
function normalizeBodyFields(data) {
  const normalizedData = { ...data };
  Object.entries(normalizedData).forEach(([key, item]) => {
    if (item.body) {
      normalizedData[key] = { ...item, body: normalizeString(item.body) };
    }
  });
  return normalizedData;
}

const Steps = ({
  classes, steps, expandPitch, closePitch, formValues, initialValues,
  createContactPitchesPreview, updateContactPitchesPreview, contactSelectedIndex, sequenceContacts,
  onContactSelected, selectedContactId,
}) => {
  const isUnCustomizedPitches = () => steps.every(s => s.pitches.some(p => p.parent));

  const renderPitch = (pitch, currentStepIndex, currentPitchIndex) => (
    <FormSection
      name={`pitchPreview-${currentStepIndex}-${currentPitchIndex}`}
    >
      <PitchPreview
        key={`pitchPreview-${currentStepIndex}-${currentPitchIndex}`}
        subject={pitch.subject}
        id={pitch.id}
        errors={pitch.errors}
        parentId={pitch.parent}
        inheritsSubject={pitch.inherits_subject}
        onExpandPitch={expandPitch}
        onCancelPitch={closePitch}
        onContactSelected={onContactSelected(contactSelectedIndex)}
        currentStepIndex={currentStepIndex}
        currentPitchIndex={currentPitchIndex}
        contactSelectedId={selectedContactId}
        collapsed={pitch.collapsed}
        initialValues={{
          subject: pitch.subject,
          body: pitch.body,
        }}
        isUnCustomizedPitches={isUnCustomizedPitches()}
      />
    </FormSection>
  );

  const onSavePreviewSteps = async () => {
    // eslint-disable-next-line no-restricted-syntax
    for (const key in formValues) {
      if (formValues[key].subject === initialValues[key].subject && formValues[key].body === initialValues[key].body) {
        // eslint-disable-next-line no-param-reassign
        delete formValues[key];
      }
    }
    const contactSelectedId = sequenceContacts.results[contactSelectedIndex].id;
    try {
      const formatData = Object.keys(formValues).map(el => el.match(/\d+/g))
        .map((arr, i) => ({
          ...steps[arr[0]].pitches[arr[1]],
          ...Object.values(formValues)[i],
        }));
      const customizedPitches = formatData.filter(p => p.parent).map(p => ({
        id: p.id,
        subject: p.subject,
        body: p.body,
        inherits_subject: p.inherits_subject,
        sequence_contact: contactSelectedId,
        parent: p.parent,
      }));
      const unCustomizedPitches = formatData.filter(p => !p.parent).map(p => ({
        subject: p.subject,
        body: p.body,
        inherits_subject: p.inherits_subject,
        sequence_contact: contactSelectedId,
        parent: p.id,
      }));
      // eslint-disable-next-line no-unused-expressions
      !isEmpty(unCustomizedPitches) && await createContactPitchesPreview(contactSelectedId, unCustomizedPitches);
      // eslint-disable-next-line no-unused-expressions
      !isEmpty(customizedPitches) && await updateContactPitchesPreview(contactSelectedId, customizedPitches);
    } catch (error) {
      if (error.errors) {
        throw new SubmissionError(error.errors);
      }
    }
  };
  const isDisabled = isEqual(normalizeBodyFields(initialValues), normalizeBodyFields(formValues));
  return (
    <div className={classes.previewStepsContainer}>
      <Button
        color="primary"
        variant="contained"
        type="submit"
        className={classes.saveButton}
        disabled={isDisabled}
        onClick={onSavePreviewSteps}
      >
          Save
      </Button>
      <div className={classes.stepsSection}>
        {steps.map((s, i) => (
          <div className={classes.stepSection} key={s.id}>
            <div className={classes.stepsTitle}>
              Step {i + 1} - {secondsToDays(Moment.duration(s.send_from_launch_duration).asSeconds()) === 0
              ? 'First day'
              : `${secondsToDays(Moment.duration(s.send_from_launch_duration).asSeconds())} days after step 1`
            }
            </div>
            <StepsFormRedux renderPitch={renderPitch} step={s} stepIndex={i} />
          </div>
        ))}
      </div>
    </div>
  );
};

Steps.propTypes = {
  classes: PropTypes.element.isRequired,
  contactSelectedIndex: PropTypes.string.isRequired,
  selectedContactId: PropTypes.string.isRequired,
  steps: PropTypes.shape({}).isRequired,
  sequenceContacts: PropTypes.shape({
    results: PropTypes.array,
  }).isRequired,
  expandPitch: PropTypes.func.isRequired,
  onContactSelected: PropTypes.func.isRequired,
  closePitch: PropTypes.func.isRequired,
  createContactPitchesPreview: PropTypes.func.isRequired,
  updateContactPitchesPreview: PropTypes.func.isRequired,
  formValues: PropTypes.shape({}).isRequired,
  initialValues: PropTypes.shape({}).isRequired,
};

export default compose(withStyles(styles, { withTheme: true }))(Steps);
